export const GET_COMPANIES = 'enterprise/GET_COMPANIES';
export const SET_COMPANIES = 'enterprise/SET_COMPANIES';
export const SET_SELECT_COMPANY = 'enterprise/SET_SELECT_COMPANY';
export const CHANGE_COMPANY = 'enterprise/CHANGE_COMPANY';
export const SET_MODULES_COMPANY = 'enterprise/SET_MODULES_COMPANY';

export default {
	GET_COMPANIES,
	SET_COMPANIES,
	SET_SELECT_COMPANY,
	CHANGE_COMPANY,
	SET_MODULES_COMPANY,
};
